import {ActionReducerMap} from '@ngrx/store';
import {AppState} from './app.state';
import {ruleReducer} from '../../features/rules/state/rule.reducer';
import {deviceReducer} from '../../features/devices/state/device.reducer';
import {cisternReducer} from '../../features/cisterns/state/cistern.reducer';
import {routerReducer} from '@ngrx/router-store';
import {notificationReducer} from '../../features/notifications/state/notification.reducer';
import {killSwitchReducer} from '../../features/dashboard/state/kill-switch.reducer';
import { deviceGroupReducer } from '../../features/devices/state/device-groups/device-group.reducer';
import {scenarioReducer} from '../../features/scenarios/state/scenario.reducer';
import { actionLogReducer } from '../../features/action-log/state/action-log.reducer';
import { pumpReducer } from '../../features/pumps/state/pump.reducer';

export const reducers: ActionReducerMap<AppState> = {
  routerState: routerReducer,

  ruleState: ruleReducer,
  deviceState: deviceReducer,
  deviceGroupState: deviceGroupReducer,
  cisternState: cisternReducer,
  pumpState: pumpReducer,
  scenarioState: scenarioReducer,
  notificationState: notificationReducer,
  actionLogState: actionLogReducer,
  killSwitchState: killSwitchReducer
};
